module.exports = __webpack_public_path__ + "static/img/b9.680ae08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b9.png
// module id = 5Pco
// module chunks = 1